import { IFieldGrouping } from '@impact/data';

export enum UsedCarPageSections {
    OVERVIEW = 'overview',
    EQUIPMENT = 'equipment',
    SPECIFICATIONS = 'specifications',
    SERVICE = 'service',
    EXCHANGE_CALCULATION = 'pricecalculation',
    INSURANCE = 'insurance',
    LAST_SECTION = 'lastsection'
}

export enum UsedCarPageSectionsMotorpoint {
    Gallery = 'gallery',
    Details = 'details',
    Equipment = 'equipment',
    Specifications = 'specifications',
    Financing = 'financing'
}

export enum UsedCarSpecTypes {
    Design = 'Design',
    Economy = 'Economy',
    General = 'General',
    Measurements = 'Measurements',
    MotorAndPerformance = 'MotorAndPerformance'
}

export enum UsedCarFinancingTypes {
    Cash = 'cash',
    Loan = 'loan',
    Leasing = 'leasing'
}

export interface IUsedCarDataItem {
    data?: number | null;
    label?: string | null;
    value?: string | null;
    vatIncluded?: boolean;
}

export interface IUsedCarPaymentOptions {
    cash?: IUsedCarDataItem;
    loanDownPayment?: IUsedCarDataItem;
    loanPerMonth?: IUsedCarDataItem;
}

export interface IUsedCarMainSpecifications {
    acceleration?: IUsedCarDataItem;
    kmPerLiter?: IUsedCarDataItem;
    topSpeed?: IUsedCarDataItem;
}

export interface IUsedCarFieldGrouping extends IFieldGrouping {
    type: UsedCarSpecTypes;
}

export interface IUsedCarSpecifications {
    allSpecifications?: IUsedCarFieldGrouping[];
    main: IUsedCarMainSpecifications;
    disclaimerText?: string;
}